<template>
  <div>
    <head-nav-bar :title="title" :fixed="true" left-arrow />
    <div class="mt-header-nav">
      <div
        style="width:100%"
        v-for="(item, index) in roomData.DataSummary"
        :key="index"
        class="mainTable"
      >
        <div style="width:100%;display: inline-block;">
          <table style="width:100%">
            <tr>
              <td style="width:33%" class="roomDateCss">
                {{ item.Date }}
              </td>
              <td class="roomOtherDateCss">
                在住
              </td>
              <td class="roomOtherDateCss">
                预定
              </td>
              <td class="roomOtherDateCss">
                可卖
              </td>
              <td class="roomOtherDateCss">
                预离
              </td>
              <td class="roomOtherDateCss">
                维修
              </td>
            </tr>
            <tr v-for="(item2, index2) in roomData.Details" :key="index2">
              <td style="width:33%" class="roomTypeCss">
                {{ item2.RoomTypeName }}<br />
                {{ item2.Quantity }} 间
              </td>
              <td class="roomOtherTypeCss">
                {{ item2.PredictCalendars[index].CheckIn }}
              </td>
              <td class="roomOtherTypeCss">
                {{ item2.PredictCalendars[index].Booking }}
              </td>
              <td class="roomOtherTypeCss">
                {{ item2.PredictCalendars[index].Saleable }}
              </td>
              <td class="roomOtherTypeCss">
                {{ item2.PredictCalendars[index].Leaving }}
              </td>
              <td class="roomOtherTypeCss">
                {{ item2.PredictCalendars[index].Repair }}
              </td>
            </tr>
            <tr>
              <td class="roomTotal">
                总计({{
                  item.CheckIn +
                    item.Booking +
                    item.Saleable +
                    item.Leaving +
                    item.Repair
                }})
              </td>
              <td class="roomOtherTypeCss2">
                {{ item.CheckIn }}
              </td>
              <td class="roomOtherTypeCss2">
                {{ item.Booking }}
              </td>
              <td class="roomOtherTypeCss2">
                {{ item.Saleable }}
              </td>
              <td class="roomOtherTypeCss2">
                {{ item.Leaving }}
              </td>
              <td class="roomOtherTypeCss2">
                {{ item.Repair }}
              </td>
            </tr>
            <tr class="roomTotal">
              <td class="roomTotal">
                出租率
              </td>
              <td class="roomTotal" colspan="5">
                {{ item.RentRate }}
              </td>
            </tr>
            <tr class="roomTotal">
              <td class="roomTotal">
                平均房价
              </td>
              <td class="roomTotal" colspan="5">
                {{ item.AvgRoomPrice }}
              </td>
            </tr>
            <tr class="roomTotal">
              <td class="roomTotal">
                房费预测
              </td>
              <td class="roomTotal" colspan="5">
                {{ item.PredictRoomPrice }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import roomApi from "../../api/room.js";
import { mapState } from "vuex";
import { Row, Col, Button } from "vant";
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
  },
  data() {
    return {
      roomData: [],
      companyId: "",
      title: "",
    };
  },
  created() {
    this.companyId = this.$route.query.Id;
    this.title = this.$route.query.Name;
    const params = {
      CompanyId: this.companyId,
      StartDate: this.user.AccountDate,
      EndDate: moment(this.user.AccountDate)
        .add(14, "d")
        .format("YYYY-MM-DD"),
    };
    this.getData(params);
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  methods: {
    getData(params) {
      var _this = this;
      var myDate = new Date();
      var tYear = myDate.getFullYear();
      roomApi.GetRoomForecast(params).then(res => {
        _this.roomData = res.Data;
        for (let i = 0; i < _this.roomData.DataSummary.length; i++) {
          var itemDateArray = _this.roomData.DataSummary[i].Date.split("-");
          _this.roomData.DataSummary[i].Date =
            tYear + "年" + itemDateArray[0] + "月" + itemDateArray[1] + "日";
        }
      });
    },
    onSearch() {
      const params = {
        CompanyId: this.user.CompanyId,
        StartDate: this.daterange[0],
        EndDate: this.daterange[1],
      };
      this.getData(params);
    },
  },
};
</script>
<style lang="less" scoped>
@headerColor: #09a8d1;
@borderColor: #e3e3e3;
.mainTable {
  margin-top: 10px;
}
.roomDateCss {
  background-color: @headerColor;
  border: 1px solid @borderColor;
  color: #edfbff;
  text-align: center;
  line-height: 40px;
  font-size: 13px;
}
.roomTypeCss {
  background-color: #09a8d1;
  border: 1px solid @borderColor;
  line-height: 15px;
  text-align: center;
  font-size: 12px;
  padding: 5px;
  color: #edfbff;
}
.roomOtherDateCss {
  background-color: @headerColor;
  border: 1px solid @borderColor;
  text-align: center;
  line-height: 20px;
  font-size: 13px;
  color: #edfbff;
}
.roomOtherTypeCss {
  border: 1px solid @borderColor;
  line-height: 20px;
  text-align: center;
  font-size: 13px;
}
.roomOtherTypeCss2 {
  border: 1px solid @borderColor;
  line-height: 40px;
  text-align: center;
  color: #0695ba;
  font-size: 13px;
}
.roomTotal {
  border: 1px solid @borderColor;
  color: #0695ba;
  line-height: 30px;
  text-align: center;
  font-size: 13px;
}
</style>
